<template>
  <el-dialog
    :title="$t('evBike.auditTitle')"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false">

    <el-form :model="auditForm" label-width="100px">
      <el-form-item :label="$t('evBike.plateNumber')">
        <span>{{ currentBike.plateNumber }}</span>
      </el-form-item>

      <el-form-item :label="$t('evBike.ownerName')">
        <span>{{ currentBike.ownerName }}</span>
      </el-form-item>

      <el-form-item :label="$t('evBike.brandModel')">
        <span>{{ currentBike.brandModel }}</span>
      </el-form-item>

      <el-form-item :label="$t('evBike.auditResult')" required>
        <el-radio-group v-model="auditForm.auditResult">
          <el-radio label="P">{{ $t('evBike.auditPass') }}</el-radio>
          <el-radio label="R">{{ $t('evBike.auditReject') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        v-if="auditForm.auditResult === 'R'"
        :label="$t('evBike.rejectReason')"
        required>
        <el-input
          type="textarea"
          v-model="auditForm.rejectReason"
          :placeholder="$t('evBike.rejectReasonPlaceholder')"
          :rows="4"
          maxlength="500"
          show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('evBike.cancel') }}</el-button>
      <el-button type="primary" @click="submitAudit">{{ $t('evBike.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { auditEvBike } from '@/api/evbike/evBikeApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AuditEvBike',
  data() {
    return {
      dialogVisible: false,
      currentBike: {},
      auditForm: {
        auditResult: 'P',
        rejectReason: ''
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(bike) {
      this.currentBike = { ...bike }
      this.auditForm = {
        auditResult: 'P',
        rejectReason: ''
      }
      this.dialogVisible = true
    },

    async submitAudit() {
      // 验证驳回原因
      if (this.auditForm.auditResult === 'R') {
        if (!this.auditForm.rejectReason || this.auditForm.rejectReason.trim() === '') {
          this.$message.warning(this.$t('evBike.rejectReasonRequired'))
          return
        }
      }

      try {
        const res = await auditEvBike({
          bikeId: this.currentBike.bikeId,
          communityId: this.communityId,
          auditStatus: this.auditForm.auditResult,
          rejectReason: this.auditForm.auditResult === 'R' ? this.auditForm.rejectReason : ''
        })

        if (res.code == 0) {
          this.$message.success(this.$t('evBike.auditSuccess'))
          this.dialogVisible = false
          this.$emit('listEvBikeData')
        } else {
          this.$message.error(res.msg || this.$t('evBike.auditFailed'))
        }
      } catch (error) {
        this.$message.error(error.message || this.$t('evBike.auditFailed'))
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
